import { Card, CardContent } from "../ui/card";
import { User, Truck, Phone, ExternalLink } from "lucide-react";

export const JobDetailInfo = ({ job }) => {
  return (
    <Card className="border-slate-200 shadow-sm rounded-sm" data-testid="details-card">
      <CardContent className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Customer */}
          <div className="flex items-start gap-3">
            <div className="p-2 bg-blue-50 rounded-sm">
              <User className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <p className="text-xs text-slate-500 uppercase font-semibold">Customer</p>
              <p className="font-medium text-slate-800">{job.customer_name}</p>
            </div>
          </div>
          {/* Excavator */}
          <div className="flex items-start gap-3">
            <div className="p-2 bg-amber-50 rounded-sm">
              <Truck className="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <p className="text-xs text-slate-500 uppercase font-semibold">Excavator</p>
              <p className="font-medium text-slate-800">{job.excavator_model}</p>
              <p className="text-xs text-slate-500">{job.excavator_serial}</p>
            </div>
          </div>
          {/* Mechanic */}
          <div className="flex items-start gap-3">
            <div className="p-2 bg-emerald-50 rounded-sm">
              <User className="w-5 h-5 text-emerald-600" />
            </div>
            <div>
              <p className="text-xs text-slate-500 uppercase font-semibold">Mechanic</p>
              <p className="font-medium text-slate-800">{job.assigned_mechanic_name || "Unassigned"}</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default JobDetailInfo;
